import template from './autoSelect.html';
import './autoSelect.scss';
import Component from '../../../lib/component';
// import {AutoSelectItem} from './item/item';
import AutoSelectedItem from './autoSelectedItem/autoSelectedItem';

let AutoSelect = Component.extend({
    template: template,
    data: {
        /**
         * 数据格式
         * {
         *     id: '',
         *     name: '',
         *     py: ''
         * }
         */
        list: [],                       // 全部列表
        /**
         * {
         *      id: '',
         *      name: ''
         * }
         */
        choosed: [],                    // 已经选择的数据
        displayType: 'popup',           // popup或者static popup为弹出的形式 static 为静态显示
        multiSelect: true,              // 是否多选
        selectBoxHeight: 'auto',           // select 框的高度
        width: 0,                       // 为0表示显示默认宽度240
        editable: true,                 // 是否可编辑
        onSelect: null,                  // 选择时的事件
        placeholder: '',
        focusItem:null,                 //记录键鼠当前指向的item
        mouseActive:false,              //标记鼠标是否在移动
        currentLength: 0,
        allDataLength: 0,
        tempList: [],
	    forbidSelect:false,
        isSetColor: false,
    },
    actions: {
        /**
         * 选取当前item
         * @param item
         */
        selectItem: function (item) {
            let checked  = item.find('input:checkbox')[0].checked;
            let dataName = item[0].getAttribute('data-name');
            dataName=dataName.substr(1,dataName.length-2);
            if (this.data.multiSelect === true) {
                // this.el.find('.result').attr('title',this.actions.calTitleArray(this.el.find('input:checked')));
                if(checked) {
                    this.actions.calTitleArray(item);
                } else {
                    this.data.choosed = this.data.choosed.filter(item => {
                        return dataName!=item.name
                    });
                }
                this.el.find('.result').attr('title',_.map(this.data.choosed, 'name'));
            } else {
                //解决多级内置二次选择‘请选择’，列表缺失问题
                if (dataName==='请选择'&&checked) {
                    this.data.choosed = [{
                        id: item.data('id').replace(/\'/g, ''),
                        name: item.data('name').replace(/\'/g, ''),
                    }];
                    this.el.find('.result').attr('title',item.data('name').replace(/\'/g, ''));
                    this.el.find('.result').val(dataName);
                    this.listWrap.hide();
                    return
                }
                this.actions.calSingleTitle(item);
            }
            this.actions.renderChoosed();
        },
        calTitleArray(item){
            if (item.find('input:checkbox')[0].checked) {
                let choosed = {
                    id: item.data('id').replace(/\'/g, ''),
                    name: item.data('name').replace(/\'/g, ''),
                };
                this.data.choosed.push(choosed);
            }
        },
        calSingleTitle(item){
            if (item.find('input:checkbox')[0].checked) {
                this.data.choosed = [{
                    id: item.data('id').replace(/\'/g, ''),
                    name: item.data('name').replace(/\'/g, ''),
                }];
                this.el.find('.result').attr('title',item.data('name').replace(/\'/g, ''));
                this.actions.hideSelectBox();
            } else {
                this.data.choosed = [];
                this.el.find('.result').removeAttr('title');
            }
        },
        /**
         * 取消选中（未使用）
         * @param id
         */
        unSelectItem: function (id) {
            _.remove(this.data.choosed, function (item) {
                return item.id === id;
            });
            this.actions.renderChoosed();
        },
        clearValue: function () {
            this.data.choosed = [];
            this.actions.renderChoosed();
        },
        /**
         * 监听搜索框输入
         * @param input
         */
        onInput: function (input) {
            this.el.find('ul li').removeClass('hovered').removeClass('match-visible');
            let value = _.trim(input.val());
            input.val(value);
            if (value === '') {
                // this.listWrap.find('li').addClass('match-visible').show();
                this.el.find('.auto-select-ul').empty();
                this.data.tempList = this.data.list;
                this.data.currentLength = 0;
                this.actions.renderItem(0);
                // this.actions._adjustScroll();
            } else {
                let searchResult = [];
                this.data.list.forEach(item => {
                    if(item['name'] && (''+item.name).indexOf(value)>=0) {
                        searchResult.push(item);
                    } else if(item['py'] && item['py'].indexOf(value)>=0) {
                        searchResult.push(item);
                    }
                });
                this.el.find('.auto-select-ul').empty();
                this.data.tempList = searchResult;
                this.data.currentLength = 0;
                this.actions.renderItem(0);
            }
            this.data.focusItem = $(this.el.find("ul").children().children()[0]).addClass('hovered');
        },
        /**
         * 展示下拉框，搜索框获取焦点，第一个备选项处于预选中状态
         */
        showSelectBox: function () {
            this.listWrap.show();
            this.data.isSelectBoxDisplayed = true;
            //设置搜索框焦点
	        !this.data.forbidSelect && this.el.find('.auto-select-text').focus();
            this.el.find('.auto-select-ul').scrollTop(0);
            //第一个备选项设置光标，并设置当前焦点dom
            this.el.find("ul li").removeClass('hovered');
            // this.data.focusItem = this.el.find("ul li:first-child").addClass('hovered');
            this.data.focusItem = $(this.el.find("ul").children().children()[0]).addClass('hovered');
            //开始监听键盘
            this.actions.startListenKeyboard();
            this.actions.startListenMouseMove();
            this.actions.listenOutsideToHideList();
        },
        /**
         * 监听外部区域，当有点时，下啦区域藏起
         */
        listenOutsideToHideList:function () {
            document.addEventListener('click',this.actions.outsideClickListener);
        },
        outsideClickListener:function(event) {
            if($(event.target).closest(this.el).length == 0 && this.listWrap && this.listWrap.is(':visible')){
                this.actions.hideSelectBox();
            }
        },
        removeClickListener:function() {
            document.removeEventListener('click',this.actions.outsideClickListener);
        },
        /**
         * 重置并隐藏下拉框
         */
        hideSelectBox: function () {
            if (this.listWrap) {
                this.actions.resetAutoSelect();
                this.listWrap.hide();
                this.data.isSelectBoxDisplayed = false;
                this.actions.stopListenKeyboard();
                this.el.find('.result').blur();
                this.actions.removeClickListener();
            }
        },
        /**
         * 选中后返回当前选中的所有项
         * @returns {Array}
         */
        getValue: function () {
            return this.data.choosed;
        },
        /**
         * 初始化已选中的复选框
         * @param choosed
         */
        setChoosed: function (choosed) {
            this.data.choosed = choosed;
            this.actions.renderChoosed();
        },
        /**
         * 创建下拉框list
         * @param list
         */
        setList: function (list) {
            this.data.list = list;
            this.reload();
            // this.actions.renderChoosed();
        },
        /**
         * 初始化已选中的复选框
         */
        renderChoosed: function () {
            this.listWrap.find('input:checkbox:checked').each(function () {
                this.checked = false;
            });
            if (this.data.onSelect) {
                this.data.onSelect(this.data.choosed);
            }
            this.trigger('onSelect', this.data.choosed);
            let html = [];
            if (this.data.choosed.length) {
                html = this.actions.loadSelect();
            }
            //多级内置选择后设置title
            this.inputResult.val(html.join(',')).attr('title',html);
            this.el.find('.select-all span').text(this.data.choosed.length);
        },
        loadSelect:function () {
            let html = [];
            this.data.choosed.forEach((item) => {
                if (!_.isUndefined(item.id)) {
                    let checkbox = this.listWrap.find(`input:checkbox[data-id="\'${item.id}\'"]`);
                    if (checkbox.length) {
                        checkbox[0].checked = true;
                    }
                    html.push(item.name);
                }
            });
            return html;
        },
        /**
         * 全选
         */
        selectAll: function () {
            if (this.data.choosed.length === this.data.list.length) {
                this.data.choosed = [];
            } else {
                this.data.choosed = this.data.list;
            }
            //多选内置筛选后，进行全选,并不是筛选条件得数据，而是所有数据得问题
            if(this.el.find('input.auto-select-text').val()!='')this.data.choosed = this.data.tempList
            this.actions.renderChoosed();
        },
        /**
         * 开始监听上下回车键
         */
        startListenKeyboard:function(){
            let that = this;
            this.el.on('keydown','.auto-select-component',function (event) {
                //任意键盘操作，将鼠标移动状态置为false，防止鼠标被动触发mouseleave或mouseenter
                that.data.mouseActive = false;
                let keyCode = event.keyCode;
                if(keyCode === 13){
                    event.preventDefault();
                    that.actions.setCheckBoxByKeyboard();
                }else if(keyCode === 40){
                    event.preventDefault();
                    // let $next = that.data.focusItem.nextAll('.match-visible');
                    let $next = that.data.focusItem.parent().nextAll();
                    that.actions._adjustEle($next);
                }else if(keyCode === 38){
                    event.preventDefault();
                    // let $prev = that.data.focusItem.prevAll('.match-visible');
                    let $prev = that.data.focusItem.parent().prevAll();
                    that.actions._adjustEle($prev);
                }
            })
        },
        _adjustEle:function(selector){
            if(selector.length > 0){
                this.data.focusItem.removeClass('hovered');
                this.data.focusItem = selector.eq(0).children();
                this.actions._adjustScroll();
            }
        },
        _adjustScroll:function () {
            let index = this.data.focusItem.parent().index();
            let scrollTop = Math.max(0,(index-2) * 30);
            this.el.find('.auto-select-ul').scrollTop(scrollTop);
            this.data.focusItem.addClass('hovered');
        },
        /**
         * 下拉框隐藏时，停止监听键盘和鼠标移动
         */
        stopListenKeyboard:function(){
            this.el.off('keydown');
            this.el.off('mousemove');
        },
        /**
         * 鼠标指向某条li，做样式处理和记录当前焦点
         */
        setMouseHover:function (event) {
            if(this.data.mouseActive === true){
                this.el.find('li').removeClass('hovered');
                this.data.focusItem = $(event.currentTarget);
                this.data.focusItem.addClass('hovered');
            }
        },
        /**
         * 键盘监听设置当前选中项的checkbox
         */
        setCheckBoxByKeyboard:function () {
            let $checkbox = this.data.focusItem.find('input:checkbox');
            if($checkbox.prop('checked') === true){
                $checkbox.prop('checked',false);
            }else{
                $checkbox.prop('checked',true);
            }
            this.actions.selectItem(this.data.focusItem);
        },
        /**
         * 开始监听鼠标移动，防止鼠标被动触发mouseleave、mouseenter
         */
        startListenMouseMove:function () {
            let that = this;
            this.el.on('mousemove','.auto-select-component',function () {
                that.data.mouseActive = true;
            });
        },
        /**
         * 退出时重置组件
         */
        resetAutoSelect:function () {
            this.el.find('.auto-select-text').val('');
            // this.el.find('ul li').addClass('match-visible').show();
            this.el.find('.auto-select-ul').empty();
            this.data.tempList = this.data.list;
            this.data.currentLength = 0;
            this.actions.renderItem(0);
            this.actions.loadSelect();
        },
        delayHideComp:function () {
            if(this.data.mouseActive === true){
                let that = this;
                this.data.timer = window.setTimeout(function () {
                    that.actions.hideSelectBox();
                },500)
            }
        },
        removeHideComp:function () {
            window.clearTimeout(this.data.timer);
        },
        _settingList:function () {
            if (this.data.selectBoxHeight === 'auto') {
                this.listWrap.css({
                    height: 'auto'
                });
                this.listWrap.find('ul').css({
                    maxHeight: '150px'
                });
            } else {
                this.listWrap.height(this.data.selectBoxHeight);
                let inputHeight = this.listWrap.find('.auto-select-text-wrap').outerHeight();
                let selectAllHeight = this.listWrap.find('.select-all').outerHeight();
                this.listWrap.find('ul').css({
                    maxHeight: (this.data.selectBoxHeight - inputHeight - selectAllHeight) + 'px'
                });
            }
            if (this.data.displayType === 'popup') {
                this.listWrap.addClass('popup');
            }
            if (this.data.width !== 0) {
                this.el.find('.auto-select-component').css('width', this.data.width);
            }
            if (this.data.editable === false) {
                this.el.find('.auto-select-component').addClass('disabled');
                this.el.find('.auto-select-component input').attr('disabled','disabled');
            }
            if (this.data.multiSelect === false) {
                this.listWrap.find('.select-all').hide();
                this.listWrap.find('ul').height('100%');
            }
        },

        renderItem: function (start) {
            this.data.currentLength += 100;
            if(this.data.currentLength > this.data.tempList.length) {
                this.data.currentLength = this.data.tempList.length;
            }
            for(let i=start; i<this.data.currentLength; i++) {
                this.append(new AutoSelectedItem({
                    data: {
                        id: this.data.tempList[i].id,
                        name: this.data.tempList[i].name,
                        py: this.data.tempList[i].py,
                        setColor:this.data.tempList[i].setColor,
                        isSetColor: this.data.isSetColor,
                    }
                }), this.el.find('.auto-select-ul'));
            }
            // this.actions.renderChoosed();
        }
    },
    binds:[
        {
            event: 'click',
            selector: 'li',
            callback: _.debounce(function (context) {
                this.actions.selectItem($(context));
            }, 50)
        },{
            event: 'input',
            selector: 'input.auto-select-text',
            callback: _.debounce(function (context) {
                this.actions.onInput($(context));
                this.actions.loadSelect();
            }, 500)
        },{
            event: 'click',
            selector: '.choosed .item',
            callback: function (context) {
                let id = $(context).data('id');
                this.actions.unSelectItem(id);
            }
        },{
            event: 'click',
            selector: '.select-all a',
            callback: function () {
                this.actions.selectAll();
            }
        },{
            event: 'click.visible',
            selector: '.result,.triangle',
            callback: function () {
                if (this.data.isSelectBoxDisplayed) {
                    this.actions.hideSelectBox();
                } else {
                    this.actions.showSelectBox();
                }
            }
        }, {
            event:'mouseenter',
            selector:'li',
            callback:function (target,event) {
                this.actions.setMouseHover(event);
            }
        },
    ],
    afterRender: function () {
        this.data.tempList = [];
        this.data.tempList = this.data.list;
        let _this = this;
        $('.auto-select-ul').scroll(function (event) {
            let ele = event.target;
            if(ele.scrollHeight - ele.scrollTop - ele.offsetHeight < 20 && _this.actions) {
                _this.actions.renderItem(_this.data.currentLength);
                _this.actions.loadSelect();
            }
        });
        this.listWrap = this.el.find('.list');
        this.inputResult = this.el.find('input.result');
        this.actions.renderItem(0);
        this.actions.renderChoosed();
        this.actions._settingList();
    },
    firstAfterRender: function () {
        if (this.data.editable === true) {
            if (this.data.displayType !== 'popup') {
                this.el.off('click.visible');
                this.el.off('mouseleave.visible');
            }
        } else {
            this.cancelEvents();
        }
    }
})

export {AutoSelect}



// WEBPACK FOOTER //
// app/components/util/autoSelect/autoSelect.js